
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export interface Market {
  id: string;
  name: string;
  short_name: string;
  time_zone: string;
}

export function useMarkets() {
  return useQuery({
    queryKey: ['markets'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('markets')
        .select('*')
        .order('short_name', { ascending: true });
      
      if (error) throw error;
      return data as Market[];
    },
  });
}
